import{createStyles as e}from"../../theme/utils/create-styles.js";var t=e({root:{},rootHorizontal:{display:"flex",flexWrap:"nowrap",alignItems:"center"},item:{}});export{t as styles};
